module.exports = __webpack_public_path__ + "static/media/infiniti.d1253be7.png";